import { createTriggerFindTargetReportContext } from '@/context/InvoiceReports';
import { AdminInvoiceReportColumn } from '@/features/admin_invoice_reports/types';

export const {
  Provider: TriggerFindTargetReportProvider,
  useTriggerFindTargetReport,
} = createTriggerFindTargetReportContext<AdminInvoiceReportColumn>();
